var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSales = function SvgSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M14.553 22.566 7.777 13h27.105l-5.98 9.566H14.554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7.832 13h27.332"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m1 23.25 20.5 25.623 20.498-25.624"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m1 23.25 20.5 25.623 20.498-25.624"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m14.664 23.25 6.833 25.623 6.833-25.624"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1 23.25 7.833 13l6.833 10.25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M14.664 23.25 21.497 13l6.833 10.25H14.664M28.332 23.25 35.165 13l6.833 10.25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m15 9-4-4M27 9l4-4M21 9V2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#Sales_svg__a)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m15 9-4-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#Sales_svg__b)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m27 9 4-4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#Sales_svg__c)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21 9V2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sales_svg__a",
    x1: 11,
    x2: 15,
    y1: 5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sales_svg__b",
    x1: 31,
    x2: 27,
    y1: 5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sales_svg__c",
    x1: 21,
    x2: 22.96,
    y1: 2,
    y2: 2.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgSales;